import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";
import React from "react";

const { Title, Paragraph, Text } = Typography;

const SmsTermsAndConditions = ({ hide, visible }) => {
   return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <span className="text-[#000833] text-[15px] mr-[12%] md:mr-[40%]">
            SMS Terms and Conditions
          </span>
          <Button
            type="text"
            icon={<CloseOutlined className="text-[20px]" />}
            onClick={hide}
          />
        </div>
      }
      open={visible}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="profile-modal"
      closeIcon={null}
      footer={null}
      bodyStyle={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <Typography>
        <Paragraph>
          <Text strong style={{ color: "#222" }}>
            Effective: July 1, 2025
          </Text>
        </Paragraph>

        <Paragraph style={{ color: "#333" }}>
          Welcome to the AdvantEdge, LLC SMS service. By subscribing to our SMS notifications, you agree to the following terms and conditions. Please read them carefully.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Service Description
        </Title>
        <Paragraph style={{ color: "#333" }}>
          Our SMS service allows you to receive notifications, updates, and promotional messages from AdvantEdge, LLC directly to your mobile device.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Subscription
        </Title>
        <Paragraph style={{ color: "#333" }}>
          By subscribing to our SMS service, you consent to receive SMS messages from us at the phone number you provided. Message frequency may vary.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Opt-In
        </Title>
        <Paragraph style={{ color: "#333" }}>
          To subscribe to our SMS service, you must opt-in by providing your mobile phone number and agreeing to these terms and conditions.
        </Paragraph>


        <Title level={4} style={{ color: "#000833" }}>
          Opt-Out
        </Title>
        <Paragraph style={{ color: "#333" }}>
          You can opt-out of our SMS service at any time by replying “STOP” to any SMS message you receive from us. After opting out, you will no longer receive SMS messages from us.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Charges
        </Title>
        <Paragraph style={{ color: "#333" }}>
          Standard message and data rates may apply. Please check with your mobile carrier for details on your plan.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Privacy
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We respect your privacy and are committed to protecting your personal information. Please refer to our Privacy Policy for more details on how we collect, use, and protect your information.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Limitation of Liability
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We are not responsible for any delays or failures in the receipt of any SMS messages. Delivery is subject to effective transmission from your mobile service provider and network availability.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Changes to Terms
        </Title>
        <Paragraph style={{ color: "#333" }}>
          We reserve the right to modify these terms and conditions at any time. Any changes will be effective immediately upon posting the updated terms and conditions on our website.
        </Paragraph>

        <Title level={4} style={{ color: "#000833" }}>
          Contact Us
        </Title>
        <Paragraph style={{ color: "#333" }}>
          If you have any questions or concerns about this SMS Privacy Policy,
          please contact us at:{" "}
          <a href="mailto:support@myrxadvantedge.com">
            support@myrxadvantedge.com
          </a>
        </Paragraph>
      </Typography>
    </Modal>
  );
}

export default SmsTermsAndConditions
